module.exports = __webpack_public_path__ + "img/christmas-tonic.c4f59601.jpg";